import { postData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initLikes(): void {
    document.addEventListener('DOMContentLoaded', () => {
        new Likes();
    });
}

class Likes {
    $buttons: NodeListOf<HTMLButtonElement>;

    constructor() {
        this.$buttons = document.querySelectorAll('.js-like-button');
        this.init();
    }

    init(): void {
        // Gestion du click sur les boutons favoris, requête ajax permettant de mettre à jour en BDD
        this.$buttons.forEach(($btn) => {
            $btn.addEventListener('click', (evt) => {
                $btn.disabled = true;
                evt.preventDefault();
                const postId = $btn.getAttribute('data-reply') ?? '';
                const mode = !$btn.classList.contains('like-button--active') ? 'add' : 'remove';
                
                postData(script_var.ajax_url, {action: 'ajax_update_likes', id: postId, mode: mode}).then(response => {
                    if (response.success) {
                        const $likesCount = $btn.parentElement?.querySelector('.likes-count');

                        if ($likesCount) {
                            $likesCount.innerHTML = response.data.count;
                        }

                        $btn.classList.toggle('like-button--active');
                        $btn.disabled = false;
                    }
                });
            });
        });
    }
}


